import { loader } from 'graphql.macro';

export const GET_USER_BY_ID = loader('./portalUserQuery.graphql');
export const UPDATE_USER = loader('./updateUserMutation.graphql');
export const ADD_ROLE = loader('./addRoleMutation.graphql');
export const DELETE_ROLE = loader('./removeRoleMutation.graphql');
export const UPDATE_ACTIVATION = loader(
  './portalUserActivationMutation.graphql'
);
export const CREATE_USER = loader('./createUserMutation.graphql');
export const CREATE_USER_ADDRESS = loader(
  './createUserAddressMutation.graphql'
);
export const GET_ROLES_BY_PARTNER_QUERY = loader('./getRolesByPartner.graphql');
export const GET_USERS_QUERY = loader('./getUsers.graphql');
